import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";
import { colors } from "../constants/GlobalStyles";

const IconHouse = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "18"}
    height={props.height || "18"}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M3.16667 8.99823H1.5L9 1.49823L16.5 8.99823H14.8333M3.16667 8.99823V14.8316C3.16667 15.2736 3.34226 15.6975 3.65482 16.0101C3.96738 16.3226 4.39131 16.4982 4.83333 16.4982H13.1667C13.6087 16.4982 14.0326 16.3226 14.3452 16.0101C14.6577 15.6975 14.8333 15.2736 14.8333 14.8316V8.99823"
      stroke={props.color || colors.secondaryAction.pressed}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 16.4982V11.4982C6.5 11.0562 6.6756 10.6323 6.98816 10.3197C7.30072 10.0071 7.72464 9.83154 8.16667 9.83154H9.83333C10.2754 9.83154 10.6993 10.0071 11.0118 10.3197C11.3244 10.6323 11.5 11.0562 11.5 11.4982V16.4982"
      stroke={props.color || colors.secondaryAction.pressed}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconHouse;
